import React from 'react';
import { NavigationContainer, NavButton } from './CharacterStyles';
import LoadingIndicator from '../../../components/common/LoadingIndicator';
import { FaArrowLeft, FaArrowRight, FaMagic } from 'react-icons/fa';

interface CharacterCreationNavigationProps {
  currentStep: number;
  isLastStep: boolean;
  loading: boolean;
  goToPreviousStep: () => void;
  goToNextStep: () => void;
  onCreateCharacter: () => void;
}

const CharacterCreationNavigation: React.FC<
  CharacterCreationNavigationProps
> = ({
  currentStep,
  isLastStep,
  loading,
  goToPreviousStep,
  goToNextStep,
  onCreateCharacter,
}) => {
  return (
    <NavigationContainer>
      <NavButton onClick={goToPreviousStep} disabled={currentStep === 0}>
        <FaArrowLeft /> Back
      </NavButton>

      {loading ? (
        <NavButton>
          <LoadingIndicator />
        </NavButton>
      ) : (
        <NavButton
          isPrimary
          onClick={isLastStep ? onCreateCharacter : goToNextStep}
        >
          {isLastStep ? 'Create' : 'Next'}
          {isLastStep ? <FaMagic /> : <FaArrowRight />}
        </NavButton>
      )}
    </NavigationContainer>
  );
};

export default CharacterCreationNavigation;
